export default {
  namespaced: true,
  state: {
    data: {
      operator: {},
      valid: false
    },
  },
  mutations: {
    UPDATE(state, value) {
      state.data.operator = value;
    },
    SET_FIELD(state, params) {
      state.data.operator[params.field] = params.value
    },
    SET_INVALID(state) {
      state.data.valid = false
    },
    SET_VALID(state) {
      state.data.valid = true
    }
  },
  actions: {
    updateField({ commit }, params) {
      if (params.field && params.value) {
        commit("SET_FIELD", params);
      }
    },
    resetFields({ commit }) {
      commit("UPDATE", {});
    },
    setInvalid({ commit }) {
      commit("SET_INVALID")
    },
    setValid({ commit }) {
      commit("SET_VALID")
    },
    setValidState({ commit }, valid) {
      if (valid) {
        commit("SET_VALID")
      } else {
        commit("SET_INVALID")
      }
    }
  }
};
